import { PAGE_ENUM } from './enum'

const defalutPage = () => PAGE_ENUM.INDEX

export default {
  namespaced: true,
  state: {
    page: defalutPage(),
    formMap: {},
    homePageUrl: '',
    common: {},
    share: {},
    signUp: {},
    form: {},
    advance: {}
  },
  mutations: {
    setHomePageUrl(state, url) {
      state.homePageUrl = url
    },
    resetPage(state) {
      state.page = defalutPage()
    },
    changePage(state, page) {
      state.page = page
    },
    setFormMap(state, obj) {
      state.formMap = Object.assign({}, state.formMap, obj)
    },
    setForm(state, arr) {
      state.form = Object.assign({}, state.form, {
        items: arr
      })
    }
  },
  actions: {
    setHomePageUrl({ commit }, payload) {
      commit('setHomePageUrl', payload)
    },
    setFormMap({ commit }, payload) {
      commit('setFormMap', payload)
    },
    setForm({ commit }, payload) {
      commit('setForm', payload)
    },
    resetDefault({ commit }) {
      commit('resetPage')
    },
    changePage({ commit }, payload) {
      commit('changePage', payload)
    }
  }
}